import { memo, useEffect } from "react";
import PurchasePageTitle from "../../components/PurchasePageTitle";
import usePurchases from "../../hooks/usePurchases";
import OptionList from "../../components/OptionList";
import PurchaseComparePlansSection from "../../components/PurchaseComparePlansSection";
import PaymentMethodSection from "../../components/PaymentMethodSection";
import BillingInformationSection from "../../components/BillingInformationSection";
import { PurchaseStepE } from "../../models/enums";
import PlanCards from "../../components/PlanCards";
import { useParams } from "react-router-dom";
import useTransaction from "../../hooks/useTransaction";
import LoadingImageElement from "../../../../Elements/LoadingContainerElement/LoadingImageElement";
import type { PurchaseParamsT } from "../../models/models";

import styles from './styles.module.scss';

const CodePurchase = memo(() => {
  const { packageType } = useParams<PurchaseParamsT>();
  const { isTransactionExecuting } = useTransaction();
  const { setDefaultSelectedOption, fetchPlans, completedStep } =
    usePurchases();

  // Get periodType param from URL
  // and set it as default selected option
  // on page mount.
  useEffect(() => {
    setDefaultSelectedOption();

    // Get details about JM plans in order to show it in the OptionList component.
    fetchPlans();
  }, []);

  return (
    <div>
      <PurchasePageTitle />
      <OptionList />
      <PurchaseComparePlansSection />
      <PaymentMethodSection />
      {completedStep === PurchaseStepE.FIRST_PURCHASE_METHOD_STEP ? (
        <BillingInformationSection />
      ) : null}
      {isTransactionExecuting && packageType === "pay-as-you-go" ? (
        <div className={styles.loadingWrapper}>
          <LoadingImageElement />
        </div>
      ) : null}
      <PlanCards />
    </div>
  );
});

export default CodePurchase;
